import React from 'react';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';

interface BlockedSubscriptionProps {
  paralyzed: boolean;
}

const BlockedSubscription = (props: BlockedSubscriptionProps) => {
  const { paralyzed } = props;
  return (
    <div className="container" id="main">
      <div className="column text-center bg-white p-3 mt-5">
        <div id="notfound">
          <p>
            <i className="big-icon material-icons mb-2">error_outline</i>
          </p>
          <h4>Sua assinatura está {paralyzed ? 'paralisada' : 'vencida'}.</h4>
          <p>
            Para visualizar seus últimos boletins acesse a seção{' '}
            <a href="/boletim_web/public/boletins">Meus Boletins</a>.
          </p>
          <p>Caso queira ativar sua assinatura ou obter mais informações entre contato conosco.</p>
          <button
            className="btn btn-info"
            type="button"
            onClick={() => {
              createTrack('Inativo - Botão quero ativar minha assinatura');
              track('intencao.botao_ativar_assinatura');
              window.location.href = '/planos';
            }}
          >
            Quero ativar minha assinatura
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockedSubscription;
